export const QUALITY_SENSE_VIEW_CONTAINER_ID = 'quality-sense.viewcontainer';
export const QUALITY_SENSE_OBSERVATIONS_VIEW_ID = 'quality-sense.view.observations';
export const QUALITY_SENSE_TOGGLE_COMMAND_ID = 'quality-sense:toggleViewContainer';
export const QUALITY_SENSE_PANEL_CONTENT_ID = 'quality-sense-observations-panel';
